<template>
  <td class="p-2">
    <button
      class="flex w-full border rounded overflow-hidden"
      :class="{ 'border-red-400': reqStats != null && reqStats === 'FAILED' }"
      @click="onClickBtn"
    >
      <div v-if="label != null" class="step px-1 py-1">{{ label }}</div>
      <div v-if="subText != null" class="date grow flex-col px-1">
        <p class="text-xs">{{ value || "-" }} %</p>
        <p class="text-xs">({{ subText }} <small>USDT</small>)</p>
      </div>
      <div v-if="subText == null" class="date grow">{{ value || "-" }}%</div>
    </button>
  </td>
</template>
<script>
export default {
  name: "TableSingleButton",
  props: { label: String, value: Number, subText: String, reqStats: String },

  methods: {
    onClickBtn() {
      this.$emit("click");
    },
  },
};
</script>
